import { render, staticRenderFns } from "./SimpleWS.vue?vue&type=template&id=011a39eb"
import script from "./SimpleWS.vue?vue&type=script&lang=js"
export * from "./SimpleWS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports